import { render, staticRenderFns } from "./Exotel.vue?vue&type=template&id=21badf3c"
import script from "./Exotel.vue?vue&type=script&lang=js"
export * from "./Exotel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports